import React from 'react'

import auth from '../../auth.js'
import { connect } from 'react-redux'
import { watchVideo } from '../../redux/actions/videoActions.jsx'

class EachVideo extends React.Component {

  // constructor(props) {
  //   super(props)
  // }

  watchVideo(e) {
    this.props.dispatch(watchVideo(e))
    auth.viewCount(e).then(response => {
      if(response) {
        console.log('view added')
      } else {
        console.log('error logging video view')
      }
    })
  }

  render() {
    return (
      <div className="each-video" key={this.props.index}>
        {this.props.video.thumbnail
          ? <a onClick={this.watchVideo.bind(this, this.props.video)} >
              <img src={this.props.video.thumbnail} alt={this.props.video.title} />
            </a>
          : <a onClick={this.watchVideo.bind(this, this.props.video)}>
              <img src={"https://videos.virtualapt.com/thumbnails/coming-soon.jpg"} alt='no thumbnail available' />
            </a>
        }
        <h4>
          <a onClick={this.watchVideo.bind(this, this.props.video)}>{this.props.video.title} <span className="company-name">{this.props.video.client === "VirtualAPT" ? null : "by " + this.props.video.client}</span></a>
        </h4>
      </div>
    )
  }
}

export default connect(store => {
  return { currentVideo: store.currentVideo.video }
})(EachVideo)